(() => {
  const bind = () => {
    const form = document.getElementById('MEEMSNewsletter');
    if (!form || form.dataset.motionBound) return;
    form.dataset.motionBound = 'true';
    const success = form.querySelector('#NewsletterSuccess');
    if (success) {
      document.title = "You're on the list — MEEMS";
      const color = document.querySelector('meta[name="theme-color"]');
      if (color) color.content = '#EDF2E9';
      const root = document.documentElement;
      clearTimeout(window.meemsTransitionSafety);
      const finish = () => {
        root.classList.remove('meems-transition', 'meems-burst', 'meems-reveal');
        clearTimeout(window.meemsTransitionSafety);
        success.focus({preventScroll: true});
      };
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        root.classList.add('meems-transition');
        const star = form.querySelector('.transition-ghost .spark');
        if (!star) { finish(); return; }
        // Remove layers from the theme's stacking context so mobile Safari
        // positions the expanding star against the viewport, not a container.
        const wipe = form.querySelector('.star-wipe');
        const wash = form.querySelector('.sage-wash');
        if (wipe) document.body.appendChild(wipe);
        if (wash) document.body.appendChild(wash);
        const rect = star.getBoundingClientRect();
        root.style.setProperty('--star-x', `${rect.left + rect.width / 2}px`);
        root.style.setProperty('--star-y', `${rect.top + rect.height / 2}px`);
        root.style.setProperty('--star-size', `${rect.width}px`);
        // Cover the farthest viewport corner even on tall mobile screens.
        root.style.setProperty('--star-cover', String(Math.hypot(document.documentElement.clientWidth, window.visualViewport ? window.visualViewport.height : innerHeight) * 4 / Math.max(rect.width, 1)));
        try {
          const started = Number(sessionStorage.getItem('meems-spin-start'));
          if (started && Date.now() - started < 120000) root.style.setProperty('--star-angle', `${((Date.now()-started)/850*360)%360}deg`);
          sessionStorage.removeItem('meems-spin-start');
        } catch (_) {}
        // Start once geometry is established, with a failsafe already active.
        // Two painted frames establish the initial state before starting.
        // The timeout starts HERE, never while scripts are still downloading.
        requestAnimationFrame(() => requestAnimationFrame(() => {
          root.classList.add('meems-burst');
          window.meemsTransitionSafety = setTimeout(finish, 1900);
          setTimeout(() => root.classList.add('meems-reveal'), 1250);
          setTimeout(finish, 1600);
        }));
      } else finish();
      return;
    }
    const button = form.querySelector('button[type="submit"]');
    if (!button) return;
    const label = button.textContent;
    let recovery;
    const reset = () => {
      clearTimeout(recovery);
      form.classList.remove('is-submitting');
      form.removeAttribute('aria-busy');
      button.textContent = label;
    };
    form.addEventListener('submit', event => {
      // Let Shopify validation and CAPTCHA handlers run first. Never cancel,
      // resubmit, fetch, or declare a successful subscription from the browser.
      queueMicrotask(() => {
        if (event.defaultPrevented) return;
        form.classList.add('is-submitting');
        try { sessionStorage.setItem('meems-spin-start', String(Date.now())); } catch (_) {}
        form.setAttribute('aria-busy', 'true');
        button.textContent = 'Signing you up…';
        clearTimeout(recovery);
        recovery = setTimeout(reset, 8000);
      });
    });
    form.addEventListener('input', reset);
    window.addEventListener('pageshow', reset);
  };
  bind();
  document.addEventListener('shopify:section:load', bind);
})();
